<template>
    <div ref="modal" class="modal fade" :class="{'show': is_loaded}" tabindex="-1" role="dialog">
        <div class="modal-dialog modal-xl">
            <div class="modal-content">
                <div class="modal-header">
                    <h4 class="modal-title">{{$trans('label.Player Information')}}</h4>
                    <a class="close" data-dismiss="modal" aria-hidden="true" @click="close()">×</a>
                </div>
                <div class="modal-body p-b-0">
                    <header>
                        <div class="player-info">
                            <h3><span>{{$trans('th.Player')}}: </span><span class="text-warning">{{utils.maskedUsername(info.username, state.user_id == info.user_id ? false : state.display_masked_username)}}</span></h3>
                            <p><span>{{$trans('label.Joined')}}: </span><span>{{info.joined}}</span> <small>[<time class="">{{info.joined_ago}}</time>]</small></p>
                        </div>
                        <hr/>
                    </header>
                    <div class="player-statistics">
                        <h5>Performance</h5>
                        <div class="performance">
                            <table class="table table-sm">
                                <tr>
                                    <td>{{$trans('label.Total Games Played')}}</td>
                                    <td>{{info.games_played}}</td>
                                </tr>
                                <tr>
                                    <td>{{$trans('label.Current Balance')}}</td>
                                    <td>{{info.balance}} {{info.currency}}</td>
                                </tr>
                                <tr>
                                    <td>{{$trans('label.Net Profit')}}</td>
                                    <td>{{info.net_profit}} {{info.currency}}</td>
                                </tr>
                                <tr>
                                    <td>{{$trans('label.All Time High')}}</td>
                                    <td>{{info.all_time_high}} {{info.currency}}</td>
                                </tr>
                                <tr>
                                    <td>{{$trans('label.All Time Low')}}</td>
                                    <td>{{info.all_time_low}} {{info.currency}}</td>
                                </tr>
                            </table>
                        </div>
                        <div class="p-t-20" v-if="chart_options.series[0].data.length">
                            <highcharts :options="chart_options"></highcharts>
                        </div>
                    </div>
                </div>
                <div class="modal-footer" v-if="chart_options.series[0].data.length">
                    <div class="pagination justify-content-center w-100">
                        <span class="mr-3" :class="{'active': pagination.total_page > pagination.page}" ref="pagination-first" @click="goPage('first')">First</span>
                        <span class="mr-3" :class="{'active': pagination.total_page > pagination.page}" ref="pagination-previous" @click="goPage('previous')">&lt; Previous</span>
                        <span class="mr-3" :class="{'active': 1 < pagination.page}" ref="pagination-next" @click="goPage('next')">Next &gt;</span>
                        <span class="mr-3" :class="{'active': 1 < pagination.page}" ref="pagination-last" @click="goPage('last')">Last </span>
                    </div>
                </div>
            </div><!-- /.modal-content -->
        </div><!-- /.modal-dialog -->
    </div>
</template>

<script>

    import {Chart} from 'highcharts-vue';
    import modal from '../libraries/modal';

    export default {
        name: "modal-user-history",
        props: ['state'],
        components: {
            highcharts: Chart
        },
        data: function()
        {
            let self = this;

            return {
                utils: utils,
                is_loaded: false,
                green: 'rgb(46, 204, 113)',
                red: 'rgb(255, 90, 95)',
                point_start: 0,

                /**
                 * User Stats
                 */
                info: {
                    currency: null,
                    user_id: null,
                    username: null,
                    joined: null,
                    joined_ago: null,
                    games_played: 0,
                    balance: 0,
                    net_profit: 0,
                    all_time_high: 0,
                    all_time_low: 0,
                    history: [],
                },

                /**
                 * Pagination
                 */
                pagination: {
                    page: 0,
                    total_page: null,
                },

                /**
                 * Chart Options
                 */
                chart_options: {
                    title: {
                        text: '',
                    },
                    chart: {
                        zoomType: 'x'
                    },
                    yAxis: {
                        title: {
                            text: 'Cumulative Net Profit', //this.$trans('chart.Profit'), //'Cumulative Net Profit'
                        },
                        labels: {
                            formatter: function () {
                                return utils.comma(this.value);
                            }
                        },
                        plotLines: [{
                            value: 0,
                            width: 1,
                            color: '#808080'
                        }]
                    },
                    series: [
                        {
                            type: null,
                            pointStart: 1,
                            showInLegend: false,
                            marker: {
                                enabled: false
                            },
                            data: [],
                        },
                    ],
                    tooltip: {
                        shared: true,
                        formatter () {
                            let index = this.x - self.point_start;
                            let item = self.info.history[index];
                            let template = `
                                <span class="chart-custom-tooltip">
                                    <span>Game ID: <b>${item.game_id}</b></span><br />
                                    <span>Played: <b>${item.created}</b></span><br />
                                    <span>Bet: <b>${item.bet_amount} ${self.info.currency}</b></span><br />
                                    <span>Bust: <b>${item.bust}x</b></span><br />
                                    <span>Cashed Out: <b>${!item.cashed_out ? '-' : item.cashed_out +'x'}</b></span><br />
                                    <span>Profit: <span style="font-weight: bold; color: ${item.profit > 0 ? self.green : self.red}">${Clib.formatDecimals(item.profit)} ${self.info.currency}</span></span><br />
                                    <span>Net Profit: <b>${Clib.formatDecimals(item.net_profit)} ${self.info.currency}</b></span><br />
                                </span>
                            `;
                            return template;
                        }
                    },
                }
            };
        },
        created()
        {
            this.info.user_id = this.state.modals.user_stats.data.user_id;
        },
        mounted()
        {
            this.state.modals.user_stats.template = this.$refs['modal'];
            modal.set(this.state.modals.user_stats);
            modal.show();

            this.init();
        },
        methods: {
            init()
            {
                this.search(1);
            },
            close()
            {
                modal.close();
            },
            goPage(type)
            {
                let go = 0;
                switch (type) {
                    case 'first': go = this.pagination.total_page; break;
                    case 'previous': go = this.pagination.page + 1; break;
                    case 'next': go = this.pagination.page - 1; break;
                    case 'last': go = 1; break;
                    default: go = 1; break;
                }
                if (go == this.pagination.page || go < 1 || go > this.pagination.total_page) {
                    return;
                }
                this.search(go);
            },
            search(page)
            {
                let self = this;

                self.pagination.page = page;

                // axios.get(`/ajax/player/history/1000510?page=${page}`).then(function(response) {
                axios.get(`/ajax/player/history/${this.info.user_id}?page=${page}`).then(function(response) {

                    modal.loaded();

                    let data = response.data.data;

                    if (response.data.code != 200) {
                        modal.close();
                        return alert(response.data.message);
                    }

                    self.is_loaded = true;
                    self.point_start                = data.point_start;
                    self.pagination.total_page      = data.total_page;

                    self.info.username              = data.username;
                    self.info.joined                = self.$moment(data.joined).format('YYYY.MM.DD');
                    self.info.joined_ago            = data.joined_ago;
                    self.info.currency              = self.state.currency.toLowerCase();
                    self.info.games_played          = utils.comma(data.games_played);
                    self.info.balance               = utils.comma(data.balance);
                    self.info.net_profit            = utils.comma(data.net_profit);
                    self.info.all_time_high         = utils.comma(data.all_time_high);
                    self.info.all_time_low          = utils.comma(data.all_time_low);
                    self.info.history               = data.history.reverse();

                    let net_profit_history = [];
                    if (self.info.history.length > 1) {

                        for (let i = 0; i < self.info.history.length; i++)
                        {
                            let history = self.info.history[i];
                            if (history)
                            {
                                let profit = Number(history.profit);
                                let net_profit = Number(history.net_profit);

                                net_profit_history.push({
                                    y: net_profit,
                                    segmentColor: self.green,
                                    color: profit < 0 ? self.red : self.green,
                                });
                                if (i > 0 && profit < 0) {
                                    net_profit_history[i - 1].segmentColor = self.red;
                                }
                            }
                        }
                        self.chart_options.series[0].type = 'coloredline';
                        self.chart_options.series[0].marker.enabled = false;

                    } else {

                        for (let i = 0; i < self.info.history.length; i++)
                        {
                            net_profit_history.push(self.info.history[i])
                        }

                        self.chart_options.series[0].type = 'line';
                        self.chart_options.series[0].marker.enabled = true;
                    }

                    self.chart_options.series[0].data = net_profit_history;
                    self.chart_options.series[0].pointStart = self.point_start;

                });
            },
        }
    }
</script>

<style scoped>

</style>
